app.service('logData', function (front, cookie) {

	function visitId() {
		var cook = front.ole ? 'oleVisit' : 'euroVisit';
		var visit = cookie.split(cook);
		return visit[0];
	}
	function visitHash() {
		var cook = front.ole ? 'oleVisit' : 'euroVisit';
		var visit = cookie.split(cook);
		return visit[2];
	}
	function customerId() {
		var cook = front.ole ? 'oleCustomer' : 'euroCustomer';
		var customer = cookie.split(cook);
		return customer[0];
	}

	/**
	 * Wartość ciasteczka testAb
	 * @return {string}
	 */
	function getTestAb() {
		return cookie.get('testAB');
	}

	return {
		visitId,
		visitHash,
		customerId,
		getTestAb
	};
});
